import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 65681 31962"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#2b2a29;stroke-width:722.287}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275342608">
        <path
          d="M13184 361h18654L19120 15980l12718 15621H13184L465 15980z"
          className="fill stroke1"
          style={{
            strokeWidth: 722.287,
          }}
        />
        <path
          d="M36885 361h6090L30255 15980l12720 15621h-6090L24167 15980z"
                    className="fill stroke1"
          style={{
            strokeWidth: 722.287,
          }}

        />
        <path
          d="M47894 361h6089L41263 15980l12720 15621h-6089L35175 15980z"
                    className="fill stroke1"
          style={{
            strokeWidth: 722.287,
          }}

        />
        <path
          d="M58833 361h6088L52203 15980l12718 15621h-6088L46115 15980z"
                    className="fill stroke1"
          style={{
            strokeWidth: 722.287,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
